"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDefaultNavigateHook = void 0;
var window_1 = __importDefault(require("../utils/window"));
var utils_1 = require("./utils");
var defaultNavigate = function (to, options) {
    if (typeof to === 'number') {
        window_1.default.history.go(to);
    }
    else {
        if (options && options.replace) {
            window_1.default.history.replaceState({}, '', (0, utils_1.formatPath)(to));
        }
        else {
            window_1.default.history.pushState({}, '', (0, utils_1.formatPath)(to));
        }
    }
};
var useDefaultNavigateHook = function () {
    return defaultNavigate;
};
exports.useDefaultNavigateHook = useDefaultNavigateHook;
